import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import Qs from 'qs'
import Print from '../src/plugs/print'
import Blob from './Excel/Blob'
import Export2Excel from './Excel/Export2Excel.js'
import bus from "./bus"
import "babel-polyfill";
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import Msg from './components/common/msg'
import echarts from 'echarts'
import store from "./store/"
import 'babel-polyfill'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
// import VueDirectiveImagePreviewer from 'vue-directive-image-previewer'
// import 'vue-directive-image-previewer/dist/assets/style.css'
// Vue.use(VueDirectiveImagePreviewer)
import Viewer from "v-viewer"
import "viewerjs/dist/viewer.css"
Vue.use(Viewer)
Viewer.setDefaults({
  Options: { 'inline': true, 'button': true, 'navbar': true, 'title': true, 'toolbar': true, 'tooltip': true, 'movable': true, 'zoomable': true, 'rotatable': true, 'scalable': true, 'transition': true, 'fullscreen': true, 'keyboard': true, 'url': 'data-source' }
})

Vue.prototype.$echarts = echarts

Vue.use(Msg);

Vue.use(BootstrapVue);

Vue.use(IconsPlugin);

Vue.use(Print)

Vue.use(ElementUI);

Vue.prototype.bus=bus;

Vue.prototype.$http = axios

Vue.config.productionTip = false


 axios.defaults.headers.post['Content-Type'] =
'application/x-www-form-urlencoded;charset=UTF-8'
axios.defaults.baseURL =  'https://hyapi.hyey.cn/'   //'http://hyapi.hyey.cn/' // 'http://fw.hyey.cn/' //61.191.148.2
//axios.defaults.baseURL =  'http://localhost:5001/'
// axios.interceptors.request.use((config) => {
//   if (config.method === 'post') {
//     config.data = Qs.stringify(config.data)
//   }
//   return config
// }, (error) => {
//   return Promise.reject(error)
// })





axios.interceptors.request.use(config => {
  if (config.method === 'post' && config.url !== 'Dls/UpLoadImage'&& config.url !== 'Home/doLogin' && config.url !== 'Home/sendMessage' && config.url !== 'Home/sendMessage2'&& config.url !== 'Home/submitZMRZ'&& config.url !== 'Home/submitZMRZ2'){
    config.data.tokenid = window.sessionStorage.getItem('tokenid')
    config.data.username = window.sessionStorage.getItem('username')
    config.data.phone_uuid =window.sessionStorage.getItem('phone_uuid')
    config.data.ipcode = localStorage.getItem("ipcode");
  }
  return config
})
//判断tokenid是否为空
if(!window.sessionStorage.getItem('tokenid')||!window.sessionStorage.getItem("username")){
  router.replace({path:'/'});
}


axios.interceptors.response.use(
  response => {
    //  console.log(response)
    //  console.log(response.data.isOk)
    //  console.log(response.data.isok)
    //  console.log(response.data.code)
    if (!response.data.isok) {
      // console.log(response.data)
        if(response.data.code==-3){
          alert('用户已掉线')
          window.sessionStorage.clear()
          router.replace({path:'/'});
        }else if(response.data.code==-1){
          alert(response.data.message)
        }
    }
    return response
  },
  error => {
    return Promise.reject(error)
  }
  )

 Vue.config.productionTip = false


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})




// WEBPACK FOOTER //
// ./src/main.js